/**
 * draft — still collecting.
 * published — a city guide may cite it.
 * closed — shut. The row stays so a guide does not recommend a dead place.
 */
export enum EstablishmentStatusEnum {
    DRAFT = 'draft',
    PUBLISHED = 'published',
    CLOSED = 'closed',
}

export const ESTABLISHMENT_STATUS_ORDER: EstablishmentStatusEnum[] = [
    EstablishmentStatusEnum.DRAFT,
    EstablishmentStatusEnum.PUBLISHED,
    EstablishmentStatusEnum.CLOSED,
];
